/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/right.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Return the substring that extracts *length* chars from *str* starting from the right.',
  examples: [
    'FROM employees\n| KEEP last_name\n| EVAL right = RIGHT(last_name, 3)',
  ],
  params: {
    string: 'The string from which to returns a substring.',
    length: 'The number of characters to return.',
  },
};

export default docs;
